module.exports = __webpack_public_path__ + "img/1484748208.085eb889.jpg";